import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_ACCOUNT_CODE = '/spe-n-account-code/v1';
const SPE_N_ACCOUNT_CODE_V2 = '/spe-n-account-code/v2';
const SPE_VIEW_N_WHITE_LABEL = '/spe-view-n-white-label/v1';
let SpeNAccountCodeProxy = class SpeNAccountCodeProxy {
    constructor(api) {
        this.api = api;
    }
    getCode(uuidWhiteLabel, uuidAccountPayment, userId) {
        let uri;
        if (userId) {
            uri = `${SPE_N_ACCOUNT_CODE}/generate/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}?userId=${userId}`;
        }
        else {
            uri = `${SPE_N_ACCOUNT_CODE}/generate/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}`;
        }
        return this.api.get(uri);
    }
    getCodeSms(uuidWhiteLabel, uuidAccountPayment, userId) {
        let uri;
        if (userId) {
            uri = `${SPE_N_ACCOUNT_CODE}/generate/sms/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}?userId=${userId}`;
        }
        else {
            uri = `${SPE_N_ACCOUNT_CODE}/generate/sms/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}`;
        }
        return this.api.get(uri);
    }
    getCodeSmsUser(payload) {
        const uri = `${SPE_N_ACCOUNT_CODE}/generate/sms-user`;
        return this.api.post(uri, payload);
    }
    checkCodeUser(code) {
        const uri = `${SPE_N_ACCOUNT_CODE}/verify-user/code/${code}`;
        return this.api.get(uri);
    }
    checkCode(uuidWhiteLabel, uuidAccountPayment, code, userId) {
        let uri;
        if (userId) {
            uri = `${SPE_N_ACCOUNT_CODE}/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}/code/${code}?userId=${userId}`;
        }
        else {
            uri = `${SPE_N_ACCOUNT_CODE}/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}/code/${code}`;
        }
        return this.api.get(uri);
    }
    //Verificar o método de preferência do usuário para validar transações.
    getCodeMethodPreference() {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/preference`;
        return this.api.get(uri);
    }
    //Define o método de preferência do usuário para validar transações.
    defineCodeMethodPreference(data) {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/preference`;
        return this.api.post(uri, data);
    }
    newSendCode(data) {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/send`;
        return this.api.post(uri, data);
    }
    deleteBiometric(uuidBioauth, body) {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/deleteBiometric/${uuidBioauth}`;
        return this.api.put(uri, body);
    }
    startInformation(devicePlatform, deviceModel, deviceManufacturer, deviceSerial) {
        const uri = `${SPE_VIEW_N_WHITE_LABEL}/start-information/front-end?devicePlatform=${devicePlatform}&deviceModel=${deviceModel}&deviceManufacturer=${deviceManufacturer}&deviceSerial=${deviceSerial}`;
        return this.api.get(uri);
    }
    hasBiometric(devicePlatform, deviceModel, deviceManufacturer, deviceSerial) {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/hasbiometric?devicePlatform=${devicePlatform}&deviceModel=${deviceModel}&deviceManufacturer=${deviceManufacturer}&deviceSerial=${deviceSerial}`;
        return this.api.get(uri);
    }
    //valida o código várias vezes até que seja válido
    validateCode(data) {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/validate`;
        return this.api.post(uri, data);
    }
    //válida o código apenas 1 vez, se digitar errado terá que gerar outro
    consumeCode(data) {
        const uri = `${SPE_N_ACCOUNT_CODE_V2}/code/consume`;
        return this.api.post(uri, data);
    }
};
SpeNAccountCodeProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountCodeProxy = __decorate([
    Injectable()
], SpeNAccountCodeProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxTokenModule = class UiPxTokenModule {
};
UiPxTokenModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService, SpeNAccountCodeProxy
        ]
    })
], UiPxTokenModule);

/*
 * Public API Surface of ui-px-token
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeNAccountCodeProxy, UiPxTokenModule };
//# sourceMappingURL=wlp-ui-px-token.js.map
